import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../header/header';
import Aside from '../../aside';
import ApiService from '../../../services/apiService';
import Spinner from '../../spinner';
import ErrorIndicator from '../../error-indicator';
import './pageAnswers.css';

class PageAnswers extends Component {
  apiService = new ApiService();

  state = {
    items: [],
    page: 1,
    limit: 20,
    total: 0,
    pages: 1,
    csvLimit: 1000,
    loading: true,
    error: false,
    filters: {
      dateFrom: '',
      dateTo: '',
      quiz: '',
      question: '',
      answer: ''
    }
  };

  componentDidMount() {
    this.setQuizFilterFromRoute();
  }

  componentDidUpdate(prevProps) {
    const prevQuiz = prevProps.match.params.quiz || '';
    const currentQuiz = this.props.match.params.quiz || '';
    if (prevQuiz !== currentQuiz) {
      this.setQuizFilterFromRoute();
    }
  }

  setQuizFilterFromRoute = () => {
    const quiz = this.props.match.params.quiz || '';
    this.setState(
      state => ({
        page: 1,
        filters: {
          ...state.filters,
          quiz
        }
      }),
      this.updateAnswers
    );
  };

  updateAnswers = () => {
    const { filters, page, limit } = this.state;
    this.setState({ loading: true, error: false });

    this.apiService
      .getChoosenAnswers({ ...filters, page, limit })
      .then(({ items, total, pages }) => {
        this.setState({
          items,
          total,
          pages: pages || 1,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: true
        });
      });
  };

  onFilterChange = e => {
    const { name, value } = e.target;
    this.setState(state => ({
      page: 1,
      filters: {
        ...state.filters,
        [name]: value
      }
    }));
  };

  onCsvLimitChange = e => {
    this.setState({ csvLimit: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    this.updateAnswers();
  };

  onReset = () => {
    this.setState(
      {
        page: 1,
        filters: {
          dateFrom: '',
          dateTo: '',
          quiz: '',
          question: '',
          answer: ''
        }
      },
      this.updateAnswers
    );
  };

  changePage = page => {
    if (page < 1 || page > this.state.pages) {
      return;
    }

    this.setState({ page }, this.updateAnswers);
  };

  getCsvUrl = () => {
    return this.apiService.getChoosenAnswersCsvUrl({
      ...this.state.filters,
      limit: this.state.csvLimit
    });
  };

  formatDate = value => {
    if (!value) {
      return '-';
    }

    return new Date(value).toLocaleString('ru-RU');
  };

  renderQuizLink = item => {
    if (!item.quiz) {
      return '-';
    }

    const label = `${item.quiz.name || item.quiz.slug || 'Квиз'}${item.quiz.id ? ` #${item.quiz.id}` : ''}`;

    if (!item.quiz.slug || !item.quiz.testType) {
      return label;
    }

    return (
      <Link className="link" to={`/admin/edit/${item.quiz.slug}/${item.quiz.testType}`}>
        {label}
      </Link>
    );
  };

  formatAnswerInfo = item => {
    const question = item.question || {};
    const answer = item.answer || {};
    const questionNumber = question.number || question.id;
    const questionLabel = questionNumber ? `Вопрос ${questionNumber}` : 'Вопрос';
    const answerLabel = answer.number ? `Ответ ${answer.number}: ${answer.text || '-'}` : `Ответ: ${answer.text || '-'}`;
    const correctness = answer.isCorrect === null || answer.isCorrect === undefined
      ? ''
      : answer.isCorrect ? 'Верный ответ' : 'Неверный ответ';
    const meta = [correctness, answer.group ? `Группа: ${answer.group}` : '']
      .filter(Boolean)
      .join(', ');

    return `${questionLabel}: ${question.text || '-'}\n${answerLabel}${meta ? `\n${meta}` : ''}`;
  };

  render() {
    const { filters, items, loading, error, page, pages, total, csvLimit } = this.state;

    return (
      <React.Fragment>
        <Header />
        <div className="admin-container">
          <div className="admin-container__inner attempts-page">
            <div className="attempts-page__head">
              <h1 className="h2 attempts-page__title">Ответы пользователей</h1>
              <div className="attempts-page__export">
                <label className="attempts-page__csv-limit">
                  Записей в CSV
                  <input
                    className="attempts-filter__input"
                    type="number"
                    min="1"
                    max="50000"
                    value={csvLimit}
                    onChange={this.onCsvLimitChange}
                  />
                </label>
                <a className="btn attempts-page__csv" href={this.getCsvUrl()}>
                  Выгрузить CSV
                </a>
              </div>
            </div>

            <form className="attempts-filter attempts-filter_answers" onSubmit={this.onSubmit}>
              <label className="attempts-filter__label">
                Дата от
                <input
                  className="attempts-filter__input"
                  type="date"
                  name="dateFrom"
                  value={filters.dateFrom}
                  onChange={this.onFilterChange}
                />
              </label>
              <label className="attempts-filter__label">
                Дата до
                <input
                  className="attempts-filter__input"
                  type="date"
                  name="dateTo"
                  value={filters.dateTo}
                  onChange={this.onFilterChange}
                />
              </label>
              <label className="attempts-filter__label">
                Квиз: id, slug или название
                <input
                  className="attempts-filter__input"
                  type="text"
                  name="quiz"
                  value={filters.quiz}
                  onChange={this.onFilterChange}
                />
              </label>
              <label className="attempts-filter__label">
                Вопрос: текст
                <input
                  className="attempts-filter__input"
                  type="text"
                  name="question"
                  value={filters.question}
                  onChange={this.onFilterChange}
                />
              </label>
              <label className="attempts-filter__label">
                Ответ: текст
                <input
                  className="attempts-filter__input"
                  type="text"
                  name="answer"
                  value={filters.answer}
                  onChange={this.onFilterChange}
                />
              </label>
              <button className="btn attempts-filter__button" type="submit">
                Найти
              </button>
              <button className="btn btn_secondary attempts-filter__button" type="button" onClick={this.onReset}>
                Сбросить
              </button>
            </form>

            {loading ? (
              <Spinner />
            ) : (
              <React.Fragment>
                <div className="attempts-page__total">Всего: {total}</div>
                <div className="attempts-table-wrap">
                  <table className="attempts-table attempts-table_answers">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Дата/время ответа</th>
                        <th>Квиз</th>
                        <th>Вопрос и ответ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.length ? items.map(item => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{this.formatDate(item.createdAt)}</td>
                          <td>{this.renderQuizLink(item)}</td>
                          <td><pre>{this.formatAnswerInfo(item)}</pre></td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="4">Ответов не найдено</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="attempts-pagination">
                  <button
                    className="btn btn_secondary"
                    type="button"
                    disabled={page <= 1}
                    onClick={() => this.changePage(page - 1)}
                  >
                    Назад
                  </button>
                  <span className="attempts-pagination__label">{page} / {pages}</span>
                  <button
                    className="btn btn_secondary"
                    type="button"
                    disabled={page >= pages}
                    onClick={() => this.changePage(page + 1)}
                  >
                    Вперёд
                  </button>
                </div>
              </React.Fragment>
            )}
            {error ? <ErrorIndicator /> : null}
          </div>
          <Aside />
        </div>
      </React.Fragment>
    );
  }
}

export default PageAnswers;
